export default {
  methods: {
    goToAgreement(agreement) {
      this.$store.commit('user/SET_AGREEMENT_CONTENT', agreement.content);
      this.$router.push({
        name: 'Agreement',
        query: {
          title: agreement.title || '协议'
        }
      })
    }
  }
}